export default "__VITE_ASSET__7b7fb9bc__"